import { MY_VIDEO_WINDOW_DEFAULT_STATE } from '../constants/streaming';
import { CLOSE } from '../constants/general';

import {
    MY_VIDEO_WINDOW_SHOW,
    MY_VIDEO_WINDOW_HIDE,
    MY_VIDEO_WINDOW_TOGGLE,
    MY_VIDEO_WINDOW_PAUSE,
    MY_VIDEO_WINDOW_UNPAUSE,
    MY_VIDEO_WINDOW_RECORD_START,
    MY_VIDEO_WINDOW_RECORD_STOP,
    MY_VIDEO_WINDOW_RECORD_ERROR,
    MY_VIDEO_WINDOW_ENABLE_SOUND,
    MY_VIDEO_WINDOW_DISABLE_SOUND,
    MY_VIDEO_WINDOW_FULLSCREEN,
    MY_VIDEO_WINDOW_COLLAPSE,
    MY_VIDEO_WINDOW_CLEAR_MESSAGE
} from '../constants/myVideoWindow';

export default function myVideoWindowReducer (state = MY_VIDEO_WINDOW_DEFAULT_STATE, action) {
    switch (action.type) {
        case MY_VIDEO_WINDOW_SHOW:
            return {
                ...state,
                shown: true
            };
        case MY_VIDEO_WINDOW_HIDE:
            return {
                ...state,
                shown: false
            };
        case MY_VIDEO_WINDOW_TOGGLE:
            return {
                ...state,
                shown: !state.shown
            };
        case MY_VIDEO_WINDOW_PAUSE:
            return {
                ...state,
                paused: true
            };
        case MY_VIDEO_WINDOW_UNPAUSE:
            return {
                ...state,
                paused: false
            };
        case MY_VIDEO_WINDOW_RECORD_START:
            return {
                ...state,
                recording: true,
                max_length: action.max_length
            };
        case MY_VIDEO_WINDOW_RECORD_STOP:
            return {
                ...state,
                max_length: 0,
                recording: false,
                message: action.message,
            };
        case MY_VIDEO_WINDOW_RECORD_ERROR:
            return {
                ...state,
                error: true,
                max_length: 0,
                recording: false,
                message: action.message,
            };
        case MY_VIDEO_WINDOW_ENABLE_SOUND:
            return {
                ...state,
                sound: true
            };
        case MY_VIDEO_WINDOW_DISABLE_SOUND:
            return {
                ...state,
                sound: false
            };
        case MY_VIDEO_WINDOW_FULLSCREEN:
            return {
                ...state,
                fullscreen: true
            };
        case MY_VIDEO_WINDOW_COLLAPSE:
            return {
                ...state,
                fullscreen: false
            };
        case MY_VIDEO_WINDOW_CLEAR_MESSAGE:
            return {
                ...state,
                message: '',
                error: false
            };
        case CLOSE:
            return {
                ...state,
                recording: false
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/myVideoWindow.js